<footer class="d-print-none" role="contentinfo">
  <div class="row">
    <div class="col-lg-4 col-12">
      <div class="footer-logo">
        <div class="row">
          <div class="col-lg-12 col-8">
            <img
              alt="République Française - eSignature"
              class="logo img-fluid"
              src="../../../assets/img/Chorus%20Pro%20AvisLogo%20-%20Grand%20-%20LogoJuin2024.svg">
          </div>
        </div>
        <span class="app-version">{{ appVersion }}</span>
      </div>
      <hr class="clearfix w-100 border d-block d-lg-none" />
    </div>

    <div *ngFor="let column of footerItems" class="col-lg-2 col-6">
      <ul class="list-unstyled">
        <li class="list-title" aria-level="1">
          {{ column.title | translate }}
        </li>

        <li *ngFor="let link of column.links" class="list-content">
          <a *ngIf="link.isExternal; else internalLink"
             target="_blank"
             href="{{ link.url | translate }}"
             hreflang="fr"
             lang="fr"
             rel="noopener noreferrer"
             [attr.aria-label]="link.ariaLabel"
             title="{{ link.title | translate }}">
            {{ link.text | translate }}
            <mat-icon *ngIf="link.isExternal"
                      aria-hidden="true"
                      class="launch-icon"
                      inline="true">
              launch
            </mat-icon>
          </a>

          <ng-template #internalLink>
            <a [routerLink]="[link.url | translate]"
               [attr.aria-label]="link.ariaLabel"
               title="{{ link.title | translate }}">
              {{ link.text | translate }}
            </a>
          </ng-template>
        </li>
      </ul>
    </div>
  </div>
</footer>
